// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Oer6","file":"styles_file__2bxCd"};